import { Box, Button } from '@mui/material'
import CustomGrid from 'common/components/CustomGrid'
import { useState } from 'react'
import { enrichFileForSigning } from './Constants'
import DocumentDialogs from './DocumentDialogs'
import TarjetaDocumento from './TarjetaDocumento'

const FirmaDocumentosGridView = ({
  documentos,
  loading,
  selectedDocs,
  setSelectedDocs,
  setTrigger,
  setErrorStatus,
  statusColorMap,
  tipoDocColorMap,
}) => {
  const [activeDoc, setActiveDoc] = useState(null)
  const [rowAction, setRowAction] = useState('')
  const [rowModalOpen, setRowModalOpen] = useState(false)

  return (
    <>
      {selectedDocs.size >= 1 && (
        <Box sx={{ mb: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const selectedDocuments = documentos.filter((d) => selectedDocs.has(d.docId))
              const signableFiles = selectedDocuments.flatMap((doc) =>
                (doc.ficheros_a_firmar ?? [])
                  .filter((f) => f.puede_firmar === 'S')
                  .map((f) => enrichFileForSigning(f, doc)),
              )
              setActiveDoc(signableFiles)
              setRowAction('F')
              setRowModalOpen(true)
            }}
          >
            Firmar {selectedDocs.size} documento{selectedDocs.size > 1 ? 's' : ''} seleccionado
            {selectedDocs.size > 1 ? 's' : ''}
          </Button>
        </Box>
      )}

      <CustomGrid
        loading={loading}
        dataSource={documentos}
        gridProps={{ spacing: 2 }}
        gridItemsProps={{ size: { xs: 12, sm: 6, md: 6, lg: 4, xl: 3 } }}
        useButtonPagination={false}
        CardLayout={({ data }) => (
          <TarjetaDocumento
            item={data}
            setTrigger={setTrigger}
            selectedDocs={selectedDocs}
            setSelectedDocs={setSelectedDocs}
            statusColorMap={statusColorMap}
            tipoDocColorMap={tipoDocColorMap}
            setActiveDoc={setActiveDoc}
            setRowAction={setRowAction}
            setRowModalOpen={setRowModalOpen}
          />
        )}
      />

      {activeDoc && rowAction && (
        <DocumentDialogs
          setErrorStatus={setErrorStatus}
          docData={Array.isArray(activeDoc) ? activeDoc : [activeDoc]}
          modalOpen={rowModalOpen}
          setModalOpen={(open) => {
            setRowModalOpen(open)
            if (!open) {
              setActiveDoc(null)
              setRowAction('')
            }
          }}
          action={rowAction}
          setTrigger={setTrigger}
        />
      )}
    </>
  )
}

export default FirmaDocumentosGridView
